import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Go the fuck home",
  "description": "",
  "published": "2016-10-20T00:00:00.000Z",
  "redirect_from": ["/blog/go-fuck-home/swizec/7139"],
  "categories": "Learning, Personal, Startups",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "YBoS-svKdgs",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`This 5 minute talk by Pam Selle is a thing of beauty. Watch it.`}</p>
    <p>{`Here are the key points. Honestly though, she expresses them much better than I do, so watch the video →`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`You are a business asset`}</strong>{`. You’re worth $X to your company. Your company knows the X… do you know the X?`}</li>
      <li parentName="ul">{`The more hours you work, the less money you’re making for your time.`}</li>
      <li parentName="ul">{`Every time you stay late after work, you’re giving that time away for free.`}</li>
      <li parentName="ul">{`Do side projects. Maybe even side projects that make money. ;)`}</li>
      <li parentName="ul"><strong parentName="li">{`You only stay late because you can’t do your work.`}</strong>{` Do your work at work. Get off Facebook, make the shit you want to happen happen, and go the fuck home when you’re done.`}</li>
      <li parentName="ul">{`When you work overtime, `}{`*`}{`*`}{`your productivity goes down. `}{`*`}{`*`}</li>
      <li parentName="ul">{`If you are good at your job, you should get it done in the time allotted.`}</li>
      <li parentName="ul"><strong parentName="li">{`Get a Life`}</strong></li>
      <li parentName="ul">{`Have an escape plan: schedule something right after work so that you’re forced to go the fuck home`}</li>
      <li parentName="ul"><strong parentName="li">{`Be an example for your team`}</strong>{`. Don’t perpetuate the “stay later to look loyaler” arms race. It’s dumb.`}</li>
      <li parentName="ul"><strong parentName="li">{`Be happy.`}</strong>{` Happier people are more productive, and if you’re more productive, you make more money. Everyone loves more money.`}</li>
    </ul>
    <p>{`You know what makes you happy? Having a life. Know what makes it possible to have a life? Going the fuck home.`}</p>
    <p>{`PS: If you’re a founder or have millions of dollars of your net worth in the company, this advice does not apply. You pour your heart and soul into that fucker, and `}<strong parentName="p">{`remember to tell your employees to go the fuck home`}</strong>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      